import { RegisterService } from "app/common/Model/RegisterService";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { assignWarrantyService, getLatestVisitBeforeAllocateRoomByDepartment } from "app/services/PatientServiceRegisterService";
import {
  allocateRoomsForUncompletedServices,
  getLatestVisitBeforeAllocateRoom,
  pagingUncompletedRegisterService,
  pagingWarrantyRegisterService,
} from "app/services/ServiceRequestItemService";
import { makeAutoObservable } from "mobx";
import moment from "moment";
import { toast } from "react-toastify";

export default class UncompletedRegisterServiceStore {
  intactSearchObject = {
    ...new SearchObject(),
    fromDate: null,
    toDate: null,
    uncompletedRegisterServices: [],
    orderDate: new Date(),
    assigner: null,
    performer: null,
    isHisCreate: true,
  };

  searchRegisterService = JSON.parse(JSON.stringify(this.intactSearchObject));

  pageRegisterService = new PageResponse();
  pageWarrantyService = new PageResponse();
  openUncompletedServicePopup = false;
  openWarrantyServicePopup = false;
  openCreateOrEditServicePopup = false;
  initRegisterService = { ...new RegisterService() };
  openConfirmDelete = null;
  openConfirmMessage = null;
  currentTab = 0;
  isLoading = false;

  isReadOnlyPopup = false; // biến này chỉ để cho nút dv còn điều trị xem k thao tác
  constructor() {
    makeAutoObservable(this);
  }

  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };

  pagingUncompletedRegisterService = async () => {
    let { healthCareSvId, groupId, department, ...ortherData } =
      this.searchRegisterService;

    let api = pagingUncompletedRegisterService;

    if (ortherData?.department?.id) {
      ortherData.departmentId = ortherData?.department?.id;
    } else {
      ortherData.departmentId = null;
    }

    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }

    if (groupId) {
      ortherData.groupId = groupId?.id;
    }

    if (this.currentTab == 1) {
      ortherData.isWarranty = true;
      ortherData.unCompleted = false;
      api = pagingWarrantyRegisterService;
    }
    return await api({ ...ortherData })
      .then(({ data }) => {
        this.pageRegisterService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu dịch vụ khách hàng có lỗi");
      });
  };

  setLoading = (state) => {
    this.isLoading = state;
  };
  pagingWarrantyRegisterService = async () => {
    console.log("lottt2");

    let { healthCareSvId, groupId, department, ...ortherData } =
      this.searchRegisterService;

    if (ortherData?.department?.id) {
      ortherData.departmentId = ortherData?.department?.id;
    } else {
      ortherData.departmentId = null;
    }

    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }

    if (groupId) {
      ortherData.groupId = groupId?.id;
    }

    return await pagingUncompletedRegisterService({
      ...ortherData,
      isWarranty: true,
    })
      .then(({ data }) => {
        this.pageWarrantyService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu dịch vụ bảo hành khách hàng có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterService) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingUncompletedRegisterService();
  };

  handleChangeFormSearchWarrantyService = (searchRegisterService) => {
    console.log("lottt3");
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingWarrantyRegisterService();
  };

  handleChangeFormSearchUncompletedService = (searchRegisterService) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingUncompletedRegisterService();
  };

  handleCloseCreateOrEditServicePopup = () => {
    this.openCreateOrEditServicePopup = false;
    this.initRegisterService = { ...new RegisterService() };
  };

  resetStore = () => {
    this.searchRegisterService = {
      ...JSON.parse(JSON.stringify(this.intactSearchObject)),
    };
    this.pageRegisterService = new PageResponse();
    this.initRegisterService = { ...new RegisterService() };
    this.openUncompletedServicePopup = false;
    this.currentTab = 0;
    this.isReadOnlyPopup = false;
  };

  resetPopupStore = () => {
    this.initRegisterService = { ...new RegisterService() };
  };

  handleCloseUncompletedServicePopup = () => {
    this.openUncompletedServicePopup = false;
    this.isReadOnlyPopup = false; // reset
    console.log("lottt");
    this.currentTab = 0;
  };

  // mở popup chỉ xem
  handleOpenUncompletedServicePopupReadOnly = async () => {
    try {
      this.isReadOnlyPopup = true; // chỉ xem
      this.openUncompletedServicePopup = true;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu dịch vụ chưa hoàn thành có lỗi");
    }
  };

  handleOpenUncompletedServicePopup = async () => {
    try {
      // await this.pagingUncompletedRegisterService();
      this.openUncompletedServicePopup = true;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu dịch vụ chưa hoàn thành có lỗi");
    }
  };

  handleOpenWarrantyServicePopup = async () => {
    try {
      // await this.pagingUncompletedRegisterService();
      this.openWarrantyServicePopup = true;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu dịch vụ bảo hành có lỗi");
    }
  };

  handleSelectUncompletedServices = (listSelectedUncompletedServices) => {
    this.searchRegisterService.uncompletedRegisterServices = [
      ...listSelectedUncompletedServices,
    ];
  };

  openConfirmAssign = false;

  handleOpenConfirmAssign = (values) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...values,
      toDate: null,
    };
    this.openConfirmAssign = true;
  };

  handleCloseConfirmAssign = () => {
    this.openConfirmAssign = false;
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };
  handleConfirmAssignService = async () => {
    try {
      if (this.isLoading) return { success: false };

      // Chặn double click: set loading ngay trước mọi await
      this.setLoading(true);

      const { department, ...assignPayload } = this.searchRegisterService;
      const departmentId = department?.id ?? assignPayload.departmentId ?? null;

      // Kiểm tra đã có lần thăm khám nào chưa
      const { data: visit } = await getLatestVisitBeforeAllocateRoomByDepartment({
        ...assignPayload,
        departmentId,
      });
      this.openConfirmAssign = false;

      if (!visit?.id) {
        this.openConfirmMessage =
          "Khách hàng chưa có lần checkin nào tại cơ sở trong ngày chỉ định";

        return { success: false };
      }

      const { data: assignedItems } = await allocateRoomsForUncompletedServices({
        ...assignPayload,
        departmentId,
      });

      if (!assignedItems?.length) {
        toast.error(
          "Không tạo được chỉ định dịch vụ. Vui lòng kiểm tra số lượng điều trị / số buổi còn lại.",
        );
        return { success: false };
      }

      const orderDate = this.searchRegisterService.orderDate;

      this.searchRegisterService.uncompletedRegisterServices = [];
      this.handleCloseUncompletedServicePopup();
      toast.success("Chỉ định dịch vụ thành công");
      this.pagingUncompletedRegisterService();

      return { success: true, orderDate };
    } catch (error) {
      console.error(error);
      toast.error("Chỉ định dịch vụ có lỗi");
      return { success: false };
    } finally {
      this.setLoading(false);
    }
  };

  handleConfirmAssignWarrantyService = async (values) => {
    try {
      if (this.isLoading) return;

      // Chặn double click cho nhánh bảo hành
      this.setLoading(true);

      // Kiểm tra đã có lần thăm khám trong ngày tại cơ sở hay chưa trước khi chỉ định bảo hành
      const { department, ...ortherData } = values || {};
      const { data: visit } = await getLatestVisitBeforeAllocateRoomByDepartment({
        ...ortherData,
        departmentId: department?.id ?? null,
      });

      if (!visit?.id) {
        this.openConfirmMessage =
          "Khách hàng chưa có lần checkin nào tại cơ sở trong ngày chỉ định";
        return;
      }

      const { data } = await assignWarrantyService({
        ...ortherData,
      });

      if (data) {
        this.openConfirmAssign = false;

        this.searchRegisterService.uncompletedRegisterServices = [];
        this.handleCloseUncompletedServicePopup();
        toast.success("Chỉ định dịch vụ thành công");
        this.pagingWarrantyRegisterService();
      }
    } catch (error) {
      console.error(error);
      toast.error("Chỉ định dịch vụ có lỗi");
    } finally {
      this.setLoading(false);
    }
  };

  resetStorePopup = () => {
    this.currentTab = 0;
  };
}
